import React from 'react';
import { string } from 'prop-types';
import Alert from '@active/react-ui/Alert';
import Locale from '@active/react-utils/i18n/Locale';
import ErrorCodeConfig from './ErrorCodeConfig';

import './WidgetError.scss';

const WidgetError = ({ errMsgCode }) => {
  const errorId = ErrorCodeConfig[errMsgCode];

  return (
    errorId ? <div className="checkout-ui-pciwidget__common-error" tabIndex="0">
      <Alert type="danger" noClose style={{ border: 'none' }}>
        <Locale id={errorId} />
      </Alert>
    </div> : null);
};

WidgetError.propTypes = {
  errMsgCode: string,
};

WidgetError.defaultProps = {
  errMsgCode: '',
};

export default WidgetError;
